import React from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { IconButton } from '../IconButton/IconButton';
import { MarginProps, TypographyProps } from '../../../theme/styledProps';

type CloseButtonSize = 'small' | 'medium';

export const StyledCloseButton = styled(IconButton).attrs(({ size }) => ({
  icon: 'fal fa-times',
  variant: 'subtleInactive',
  size,
}))`
  i {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.neutral['500']};
    flex-shrink: 0;

    ${variant<TypographyProps, CloseButtonSize>({
      prop: 'size',
      variants: {
        small: {
          fontSize: 'h6',
        },

        medium: {
          fontSize: 'h3',
        },
      },
    })}
  }
`;

StyledCloseButton.defaultProps = {
  'aria-label': 'Close',
};

export interface Props extends React.ComponentPropsWithoutRef<'button'>, MarginProps {
  size?: CloseButtonSize;
}

export const CloseButton: React.FC<Props> = ({ size = 'medium', ...rest }) => (
  <StyledCloseButton size={size} {...rest} />
);
